<template lang="pug">
  header.header
    .container
      .logos
        a.logo-rosatom(href="https://www.rosatom.ru/" target="_blank")
          img(src="@/assets/img/logo.png")
        a.logo-home(href="https://homo-science.ru/" target="_blank")
          img(src="@/assets/img/logo_home.png")
        .burger(:class="{'burger--closer': menuIsOpen}"
          @click="toggleMenu()")
          span
          span
          span
      .nav(:class="{open: menuIsOpen}")
        .nav__wrapper
          a(href="https://atom75.ru/" target="_blank") Главная
          a(href="https://atom75.ru/#history" target="_blank") История атомной промышленности
          a(href="https://calendar.atom75.ru/" target="_blank") Календарь событий
          a(href="https://www.next75.ru/" target="_blank") Конференция NEXT 75
          a(href="https://calendar.atom75.ru/forjournalists" target="_blank") Медиакит
      .socials.socials--desktop
        a(href="https://vk.com/rosatomru" target="_blank")
          img(src="@/assets/img/socials/vk.png")
        a(href="https://www.facebook.com/rosatom.ru" target="_blank")
          img(src="@/assets/img/socials/facebook.png")
        a(href="https://www.instagram.com/rosatom_ru/" target="_blank")
          img(src="@/assets/img/socials/instagram.png")
</template>

<script>
export default {
  name: "Header",
  data: () => ({
    menuIsOpen: false,
  }),
  methods: {
    toggleMenu(event) {
      if (!event) {
        event = this.menuIsOpen ? 'close' : 'open';
      }
      if (event === 'open') {
        this.menuIsOpen = true;
        this.$store.commit('pageHidden')
      } else if (event === 'close') {
        this.menuIsOpen = false;
        this.$store.commit('pageDelHidden')
      }
    },
  }
}
</script>

<style scoped lang="scss">
  .header {
    height: to_rem(158px);
    background: #fff;
    .container {
      display: flex;
      justify-content: space-between;
      align-items: center;
      height: 100%;
    }
    .logos {
      display: flex;
      align-items: center;
      width: 20rem;
      .logo-rosatom {
        width: 3.8rem;
        margin-right: 3.8rem;
        img {
          width: 100%;
        }
      }
      .logo-home {
        width: 11rem;
        transform: translateY(-0.5rem);
        img {
          width: 100%;
        }
      }
      .burger {
        display: none;
      }
    }
    
    .nav {
      &__wrapper {

      }
      a {
        margin: 0 0.88rem;
        font-size: to_rem(18px);
        color: #000;
      }
    }
    .socials {
      display: flex;
      justify-content: flex-end;
      width: 12rem;
      a {
        width: to_rem(38px);
        height: to_rem(38px);
        margin-left: 1.5rem;
        img {
          width: 100%;
        }
      }
      &--mobile {
        display: none;
      }
    }
  }

  .mobile .header {
    height: 4.65rem;
    .container {
      padding: 0;
    }
    .logos {
      position: relative;
      z-index: 10000;
      justify-content: space-between;
      width: 100%;
      height: 100%;
      padding: 0 1.3rem;
      box-shadow: 0 0 1rem rgba(#000, 0.3);
      .logo-rosatom {
        width: 2.5rem;
        margin-right: 0;
      }
      .logo-home {
        width: 6.2rem;
        transform: translateY(-0.1rem);
      }
      .burger {
        position: relative;
        display: flex;
        width: 2.3rem;
        height: 1.6rem;

        span {
          position: absolute;
          width: 100%;
          height: 3px;
          border-radius: 3px;
          background: #182a76;
          transform: translateY(-50%);
          transition: top .2s .3s, transform .3s, opacity .3s .3s, background-color .3s;
          transform-origin: center center;

          &:nth-of-type(1) {
            top: 0;
          }

          &:nth-of-type(2) {
            top: 50%;
          }

          &:nth-of-type(3) {
            top: 100%;
          }
        }

        &--closer {
          span {
            transition: top .2s, transform .3s .2s, opacity .3s, background-color .3s;

            &:nth-of-type(1) {
              top: 50%;
              transform: translateY(-50%) rotate(45deg);
            }

            &:nth-of-type(2) {
              opacity: 0;
            }

            &:nth-of-type(3) {
              top: 50%;
              transform: translateY(-50%) rotate(-45deg);
            }
          }
        }
      }
    }
    .nav {
      overflow: auto;
      position: fixed;
      z-index: 1000;
      top: 0;
      left: 0;
      right: 0;
      width: 100%;
      background: #fff;
      transform: translateX(-100%);
      opacity: 0;
      transition: .3s;

      &__wrapper {
        display: flex;
        flex-direction: column;
        padding-top: 4.65rem;
      }

      a {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        height: 4.5rem;
        margin: 0;
        font-size: 1.2rem;
        color: #182a76;
        &:active {
          background: #182a76;
          color: #fff;
        }
      }

      &.open {
        transform: translateX(0);
        opacity: 1;
      }
    }
    .socials {
      &--desktop {
        display: none;
      }
      &--mobile {
        display: flex;
      }
    }
  }
</style>